<template>
  <div class="banner_box">

    <div class="container">
      <myHeader></myHeader>
      <div id="slide">
        <div class="item slideitem" v-for="(item, index) in data.source" :key="item.id"
          :style="{ backgroundImage: `url(${item.url})` }">
          <video autoplay muted playsinline loop v-if="index == 1" class="video">
            <source :src="item.video" type="video/mp4" />
          </video>

          <div class="content">
            <!-- <div class="subheading">Good Source Goods</div> -->
            <div class="name">{{ item.name }}</div>
            <div class="des">{{ item.description }}</div>
            <div class="icon_box">
              <!-- <lord-icon src="https://cdn.lordicon.com/vixtkkbk.json" trigger="hover" class="icon">  
                        </lord-icon>   -->
            </div>
            <div class="bottom-box">
              <div class="hand_box">
                <img src="../assets/img/icon/hand.png" />
              </div>
              <button class="dea-botton" @click="goto('/news')">了解更多</button>
            </div>

          </div>
        </div>
      </div>

      <div>
        <!-- <div class="buttons"> -->
        <div class="s_button left_s_button" @click="previous()">
          <img src="@/assets/img/previous.png" class="imgleft" />
        </div>
        <div class="s_button right_s_button" @click="nextpage()"> <img class="imgleft"
            src="@/assets/img/nextpage.png" /></div>
        <!-- </div> -->
        <div class="schedule">
          <div v-for="(item, index) in data.source" :key="item.id" class="schedule_li"
            :class="index == data.centerindex ? 'schedule_li_avtive' : ''"></div>
        </div>
        <div class="index_item">
          0{{ data.centerindex + 1 }}
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { onMounted } from "vue";
import { reactive, ref, toRefs, } from "@vue/reactivity";
import myHeader from './myHeader.vue'
import { getbanner, } from '@/comm/api'
import { useRouter } from 'vue-router';
const source = [
]

export default {

  name: "banner",
  components: {
    myHeader
  },
  props: {

  },
  setup(props) {
    let data = reactive({
      direction: true,
      timer: null,
      source: [],
      centerindex: 0
    });
    function previous() {

      console.log(data.source, '调整前面')
      if (data.centerindex < data.source.length - 1) {
        data.centerindex--
      } else {
        data.centerindex = 0
      }
      // data.source.push(data.source[data.source.length-1])
      data.source = [data.source[data.source.length - 1], ...data.source.slice(0, data.source.length - 1)]
      // data.source.splice(1,0,data.source[data.source.length-1],)
      // data.source.pop()
    }
    function nextpage() {
      console.log(data.source, '调整前面')
      if (data.centerindex < data.source.length - 1) {
        data.centerindex += 1
      } else {
        data.centerindex = 0
      }
      data.source = [...data.source.slice(1), data.source[0]]
    }
    const getbannerList = async (type) => {
      try {
        const res = await getbanner({ type: type });
        console.log(1, res);
        if (res.code == 1) {
          data.source = res.data
        }
      } catch (err) {
        console.error("失败", err);

      }
    };
    const router = useRouter()
    const goto = (path) => {
      router.push(path)
    }
    onMounted(() => {
      getbannerList(1)
    })
    return {
      source,
      data,
      previous,
      nextpage,
      goto
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

.banner_box {
  height: 900px;
  position: relative;
}

.left_s_button {
  position: absolute;
  left: 100px;
  top: 50%;
  transform: translateY(-50%);

}

.right_s_button {
  position: absolute;
  right: 3%;
  top: 50%;
  transform: translateY(-50%);

}

@media screen and (max-width: 1800px) {

  // 当屏幕宽度小于等于 600px 时应用的样式
  .banner_box {
    max-height: 717px !important;

  }

  .buttons {
    bottom: 11% !important;
  }

  .schedule {
    width: 390px !important;
    bottom: 16% !important;
    left: 63% !important;
  }

  .index_item {
    bottom: 12% !important;
    right: 9% !important;
  }

  .item .content {
    left: 10% !important;

  }

  // .slideitem{
  //   margin-top:-100px !important;
  // }

}

body {
  background-color: #eaeaea;
  // overflow: hidden;
  overflow-x: hidden;
}

.container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #f5f5f5;
  padding: 55px;
  box-shadow: 0 30px 50px #dbdbdb;
}

#slide {
  width: max-content;
  margin-top: 50px;

}

.item {
  width: 200px;
  height: 300px;
  background-position: 50%, 50%;
  display: inline-block;
  position: absolute;
  top: 55%;
  /* transform: translateY(-50%); */
  margin-top: -150px;
  border-radius: 20px;
  box-shadow: 0 30px 50px #505050;
  transition: .5s;
  background-size: 340px 300px;
}

.item:nth-child(1),
.item:nth-child(2) {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;

  /* transform: translateY(0); */
  margin-top: 0px;
  border-radius: 0;
  box-shadow: none;

}

.item:nth-child(3) {
  left: 50%;
  display: none;
  animation: 1s cubic-bezier(0.55, 0.085, 0.68, 0.53) 0s 1 normal both running blur-out-contract-bck;
}

// #slide:hover .item:nth-child(3) {
//   display: block;
//   animation: 2s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s 1 normal both running bounce-left;

// }

@for $i from 4 through 20 {

  // #slide:hover .item:nth-child(#{$i}) {
  //   display: block;
  //   animation: 2s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s 1 normal both running bounce-left;
  // }

  .item:nth-child(#{$i}) {
    left: calc(50% + 220 *#{($i - 3)}px); // 只是一个示例，用于展示如何应用不同的样式  
    display: none;
    animation: 1s cubic-bezier(0.55, 0.085, 0.68, 0.53) 0s 1 normal both running blur-out-contract-bck;
  }
}

/* .item:nth-child(4) {
  left: calc(60% + 220px);
}

.item:nth-child(5) {
  left: calc(60% + 440px);
}
.item:nth-child(6) {
  left: calc(60% + 660px);
} */

.item .content {
  width: 300px;
  position: absolute;
  left: 15%;
  top: 55%;
  transform: translateY(-50%);
  font-family: "Alimama_DongFangDaKai_Regular";
  color: #c7ecee;
  display: none;

}

.item .content button {
  border-radius: 26px;
  border: 1px solid #FFFFFF;
  opacity: 0;
  padding: 10px 46px !important;
  color: #fff;
  background: transparent;
  cursor: pointer;
}

.item:nth-child(2) .content {
  display: block;
}

.item .name {
  font-size: 59px;
  font-weight: bold;
  font-family: Microsoft YaHei;
  opacity: 0;
  color: #FFFFFF;
  animation: showcontent 1s ease-in-out 1 forwards;
}

.item .des {
  margin: 20px 0;
  font-size: 15px;
  width: 180px;
  opacity: 0;
  color: #FFFFFF;
  animation: showcontent 1s ease-in-out 0.3s 1 forwards;
}

.subheading {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 15px;
  color: #FFFFFF;
  animation: showcontent 1s ease-in-out 0.3s 1 forwards;
}

.item button {
  padding: 10px 20px;
  border: none;
  opacity: 0;
  animation: showcontent 1s ease-in-out 0.6s 1 forwards;
}

.bottom-box {
  animation: showcontent 1s ease-in-out 0.6s 1 forwards;
}

@keyframes showcontent {
  from {
    opacity: 0;
    transform: translateY(100px);
    filter: blur(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }
}

.buttons {
  width: auto;
  position: absolute;
  bottom: 10%;
  margin-left: -50px;
  text-align: center;
  left: 53%;

}

.schedule {
  width: 510px;
  position: absolute;
  bottom: 14%;
  margin-left: -20px;
  text-align: center;
  left: 61%;
  display: flex;
  align-content: center;

  .schedule_li {
    height: 1px;
    background: rgba(255, 255, 255, 0.4);
    width: 20%;
  }

  .schedule_li_avtive {
    background: #38C9C8 !important;
  }
}

.index_item {
  position: absolute;
  bottom: 11%;
  margin-left: -20px;
  text-align: center;
  right: 10%;
  font-family: DINCond-Black;
  font-weight: 400;
  font-size: 55px;
  color: #FFFFFF;

}

.s_button {
  display: inline-block;
  width: 70px;
  height: 70px;
  line-height: 50px;
  text-align: center;
  color: gray;
  // background-color: rgb(255, 255, 255, 0.3);
  font-size: 25px;
  border-radius: 20px;
  font-weight: bold;
  // border: 1px solid #555;
  margin: 0 10px;
  transition: .5s;
}

.imgleft {
  width: 70px;
  height: 70px;
}

.s_button:hover {
  cursor: pointer;
  // background-color: #ccc;
}

.hand_box {
  width: 40px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 50%;
  position: relative;
  margin-right: 10px;
}

.hand_box img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.icon {
  width: 50px;
  height: 50px
}

.icon_box {

  animation: showcontent 1s ease-in-out 0.6s 1 forwards;
}

.video {

  position: fixed;
  right: 0px;
  border: 0px;
  object-fit: fill;
  // min-width: 100%;
  // min-height: 100%;
  // height: auto;
  // width: auto;
  width: 100%;
  height: 100%;
  animation: 1.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) 0s 1 normal both running text-focus-in;
}

.bottom-box {
  display: flex;
  align-items: center;
}

// .video:hover+.content {
//   //这个是必须要相邻的兄弟元素
//   display: none;
// }

@-webkit-keyframes text-focus-in {
  0% {
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0
  }

  100% {
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1
  }
}

@keyframes text-focus-in {
  0% {
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0
  }

  100% {
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1
  }
}

@-webkit-keyframes bounce-left {
  0% {
    -webkit-transform: translateX(-48px);
    transform: translateX(-48px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 1
  }

  24% {
    opacity: 1
  }

  40% {
    -webkit-transform: translateX(-26px);
    transform: translateX(-26px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in
  }

  65% {
    -webkit-transform: translateX(-13px);
    transform: translateX(-13px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in
  }

  82% {
    -webkit-transform: translateX(-6.5px);
    transform: translateX(-6.5px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in
  }

  93% {
    -webkit-transform: translateX(-4px);
    transform: translateX(-4px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in
  }

  25%,
  55%,
  75%,
  87%,
  98% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out
  }

  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1
  }
}

@keyframes bounce-left {
  0% {
    -webkit-transform: translateX(-48px);
    transform: translateX(-48px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 1
  }

  24% {
    opacity: 1
  }

  40% {
    -webkit-transform: translateX(-26px);
    transform: translateX(-26px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in
  }

  65% {
    -webkit-transform: translateX(-13px);
    transform: translateX(-13px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in
  }

  82% {
    -webkit-transform: translateX(-6.5px);
    transform: translateX(-6.5px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in
  }

  93% {
    -webkit-transform: translateX(-4px);
    transform: translateX(-4px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in
  }

  25%,
  55%,
  75%,
  87%,
  98% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out
  }

  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1
  }
}

@-webkit-keyframes blur-out-contract-bck {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-filter: blur(.01);
    filter: blur(.01)
  }

  100% {
    letter-spacing: -.5em;
    -webkit-transform: translateZ(-500px);
    transform: translateZ(-500px);
    -webkit-filter: blur(12px) opacity(0);
    filter: blur(12px) opacity(0)
  }
}

@keyframes blur-out-contract-bck {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-filter: blur(.01);
    filter: blur(.01)
  }

  100% {
    letter-spacing: -.5em;
    -webkit-transform: translateZ(-500px);
    transform: translateZ(-500px);
    -webkit-filter: blur(12px) opacity(0);
    filter: blur(12px) opacity(0)
  }
}
</style>